// Internal Imports
import { API_ENDPOINTS } from "../../constants";
import { put, post, deleteApi, get } from "../../api/index";

// Destructuring
const { APIS } = API_ENDPOINTS;

// Meta field services
export const fetchMetaFields = (docMode, objectId) =>
  new Promise((resolve, reject) => {
    get(`${APIS.META_FIELDS}/${docMode}/${objectId}`)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

export const fetchGlobalMetaFields = () =>
  new Promise((resolve, reject) => {
    get(APIS.META_FIELDS)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

export const createMetaField = (docMode, objectId, metaFieldInfo) =>
  new Promise((resolve, reject) => {
    post(`${APIS.META_FIELDS}/${docMode}/${objectId}`, metaFieldInfo)
      .then(res => resolve(res))
      .catch(err => reject(err.response));
  });

export const updateMetaField = (docMode, objectId, updatedObject) =>
  new Promise((resolve, reject) => {
    put(`${APIS.META_FIELDS}/${docMode}/${objectId}`, updatedObject)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

export const deleteMetaField = (docMode, objectId, metaFieldItemName) =>
  new Promise((resolve, reject) => {
    deleteApi(
      `${APIS.META_FIELDS}/${docMode}/${objectId}/fields/${metaFieldItemName}`,
    )
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

export const updateTemplateMetaFieldInDoc = (
  docMode,
  objectId,
  metaGroupId,
  updatedMetaFieldName,
  updatedObject,
) =>
  new Promise((resolve, reject) => {
    put(
      `${APIS.META_FIELDS}/values/${metaGroupId}/${docMode}/${objectId}`,
      updatedObject,
    )
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });
